import HttpService from "@core/services/http/http.service";

class _StandardizeContentService {
  public getStandardizeContent(content: string) {
    return HttpService.post<{
      data: {
        content: string;
      };
    }>(
      "/admin/api/v3/books/standardize-content",
      {
        body: { content },
      }
    );
  }
}

const StandardizeContentService = new _StandardizeContentService();

export default StandardizeContentService;
